module.exports = __webpack_public_path__ + "img/5-2.8a9d4c31.svg";